import { legalEntityContactSchema } from '../../schemas';
import * as actionTypes from '../../constants/registerContactsActionTypes';
import { createAsyncAction, normalizeHelper } from '../../utils/asyncHelpers';
import {
  legalEntityContactsFetch,
  legalEntityContactAdd,
  legalEntityContactUpdate,
  legalEntityContactDelete,
} from '../actionHelpers/endpoints';

export const fetchLegalEntityContacts = createAsyncAction(
  actionTypes.ENTITY_CONTACTS_FETCH,
  legalEntityContactsFetch,
  normalizeHelper([legalEntityContactSchema])
);

export const addLegalEntityContact = createAsyncAction(
  actionTypes.ENTITY_CONTACTS_ADD,
  legalEntityContactAdd,
  normalizeHelper(legalEntityContactSchema)
);

export const updateLegalEntityContact = createAsyncAction(
  actionTypes.ENTITY_CONTACTS_UPDATE,
  legalEntityContactUpdate,
  normalizeHelper(legalEntityContactSchema)
);

export const deleteLegalEntityContact = createAsyncAction(
  actionTypes.ENTITY_CONTACTS_DELETE,
  legalEntityContactDelete
);
